module.exports = __webpack_public_path__ + "img/wizardDice.fd21f7a7.png";